<script lang="ts" setup>
const lists = ref([
  {
    title: '我在momo、pchome買都沒有點數回饋嗎?',
    text: '生活有亮點計畫是恆隆行的會員制度，因此只有在恆隆行指定通路，包含全台恆隆行百貨專櫃、dyson百貨專櫃、恆隆行kitchenware、WMF百貨專櫃、恆隆行線上購物、恆隆行線上購APP，以及恆隆行維修中心維修或深層清潔付費服務才有點數回饋。 '
  },
  {
    title: '請問如果要在恆隆行維修付費有回饋點數嗎？ ',
    text: '有的，跟直營通戶消費購物一樣，依會員級別享0.5%–2.5% 點數回饋。'
  },
  {
    title: '請問點數回饋怎麼用？ ',
    text: '恆隆行點數適用範圍為全台hengstyle恆隆行百貨專櫃、dyson百貨專櫃、hengstyle恆隆行線上購網站及恆隆行線上購APP、恆隆行kitchenware、WMF百貨專櫃皆適用 ，或使用恆隆行維修及深層清潔付費服務亦可享有該會員制度之權益，華泰恆隆行Outlet不適用。 '
  },
  {
    title: '購物商品就自動保固，我要去哪裡查詢我的保固清單呢？',
    text: '可直接於恆隆行官方LINE帳號或官網查詢。'
  },
  
])
</script>

<template>
  <section class="sectionFaq">
    <div class="sectionFaq__inner">
      <div class="sectionFaq__top">
        <div class="sectionFaq__top__tw">常見問答</div>
        <div class="sectionFaq__top__en">FAQ</div>
      </div>
      <ul class="sectionFaq__lists">
        <li v-for="(item, index) in lists" :key="index">
          <FaqItem :data="item" />
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.sectionFaq {
  position: relative;
  width: 100%;
  padding-top: toRem(120);
  padding-bottom: toRem(120);
  background-color: $color-white-1;
  @include grid;

  @include max-media(960) {
    padding-left: toRem(24);
    padding-right: toRem(24);
  }

  @include max-media(767) {
    margin-bottom: toRem(-100);
  }

  &__inner {
    grid-column: 4 / span 6;

    @include max-media(960) {
      grid-column: 1 / span 12;
    }
  }

  &__lists {
    border-bottom: 1px solid $color-gray-line;
  }

  &__top {
    text-align: center;
    margin-bottom: toRem(32);

    &__tw {
      margin-bottom: toRem(24);
      font-size: toRem(28);
      font-weight: 500;
      line-height: 1.3;

      @include max-media(480) {
        font-size: toRem(22);
      }
    }

    &__en {
      font-size: toRem(80);
      font-weight: 500;
      line-height: 0.8;
      font-family: $font-TextaAlt;
      color: $color-brand-3;

      @include max-media(480) {
        font-size: toRem(60);
      }
    }
  }
}
</style>
